module.exports = __webpack_public_path__ + "img/hand.fb48d654.gif";